import { createContext, useContext, useState, useCallback } from "react";

const AuthModalContext = createContext();

export function AuthModalProvider({ children }) {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [modalView, setModalView] = useState("auth"); // 'auth' or 'resetPassword'
  const [resetEmail, setResetEmail] = useState("");

  // Accept optional email for resetPassword view
  const openAuthModal = useCallback((view = "auth", email = "") => {
    setModalView(view);
    setAuthModalOpen(true);
    if (view === "resetPassword" && email) setResetEmail(email);
  }, []);
  const closeAuthModal = useCallback(() => setAuthModalOpen(false), []);

  return (
    <AuthModalContext.Provider
      value={{
        authModalOpen,
        openAuthModal,
        closeAuthModal,
        modalView,
        setModalView,
        resetEmail,
      }}
    >
      {children}
    </AuthModalContext.Provider>
  );
}

export function useAuthModal() {
  const context = useContext(AuthModalContext);
  if (!context) {
    throw new Error("useAuthModal must be used within an AuthModalProvider");
  }
  return context;
}
